import { useMemo } from 'react';
import { useSuggestions } from '~/hooks/useSuggestions';
import { getNameFromSearch } from '~/scripts/getNameFromSearch';
import { Searches } from '~/types/searches';

export function useNameFromSearch(
  search: Searches.StoredSearchObject | undefined
) {
  const suggestions = useSuggestions();

  return useMemo(() => {
    if (!search || !suggestions?.length) {
      return '';
    }

    return getNameFromSearch(search, suggestions || []);
  }, [suggestions, search]);
}
